import React, { memo } from 'react'

const DisplayPill = ({ label }) => {
    return (
        <span className={'displayPill'}>
            <p className={'displayPill__label'}>{label}</p>
        </span>
    )
}

export default memo(DisplayPill)
